import Suggestions from './suggestions';
export default Suggestions;